package er.prateek.crossly.content

import crossly.shared.generated.resources.Res
import er.prateek.crossly.data.model.CrosswordPack
import kotlinx.serialization.json.Json

private val packJson = Json { ignoreUnknownKeys = true }

class BundledContentSource {
    suspend fun loadCrosswordPack(resourcePath: String): CrosswordPack {
        val bytes = Res.readBytes(resourcePath)
        return packJson.decodeFromString(CrosswordPack.serializer(), bytes.decodeToString())
    }
}
